// extracted by mini-css-extract-plugin
export var $animation_name = "BlogHeader-module--$animation_name--cae10";
export var BlogHeader = "BlogHeader-module--BlogHeader--d3827";
export var BlogHeader___inverted = "BlogHeader-module--BlogHeader___inverted--4e3b5";
export var BlogSubHeader = "BlogHeader-module--BlogSubHeader--b65e6";
export var BlogSubHeader___inverted = "BlogHeader-module--BlogSubHeader___inverted--40493";
export var Inner = "BlogHeader-module--Inner--ce28f";
export var Wrapper = "BlogHeader-module--Wrapper--56c80";
export var Wrapper___withImage = "BlogHeader-module--Wrapper___withImage--51cf0";